import { render, staticRenderFns } from "./TeacherLeaderConfigForm.vue?vue&type=template&id=70e0a6ca"
import script from "./TeacherLeaderConfigForm.vue?vue&type=script&lang=js"
export * from "./TeacherLeaderConfigForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports